import React from 'react'
import './style.css'
import PropTypes from 'prop-types'


const FullScreenContainer = (props) => (
    <div {...props} className={'nrt-fullscreen-container ' + props.className }>
        {props.children}
    </div>
)


FullScreenContainer.propTypes = {
    children: PropTypes.any.isRequired,
}


export default FullScreenContainer


// WEBPACK FOOTER //
// ./src/components/_common/_containers/FullScreenContainer/index.js